import React, { useEffect } from "react";
import { Alert, Container, Row } from "react-bootstrap";
import { useStoreActions } from "easy-peasy";
import Loader from "../../../components/widgets/Loader";
import useCustomGetStoreState from "../../../hooks/useCustomGetStoreState";
import ProductsTableComponent from "../../../components/orders/products/ProductsTableComponent";

const ProductsList = () => {
    const { allProductsLogistics, isFetchingAllProductsLogistics } = useCustomGetStoreState("orders");
    const { fetchAllProductsLogistics } = useStoreActions(actions => actions.orders);

    useEffect(() => {
        fetchAllProductsLogistics();
    }, []);

    return <Container fluid>
        <Row>
            {isFetchingAllProductsLogistics && <Loader />}
            {allProductsLogistics?.length > 0 && <ProductsTableComponent products={allProductsLogistics} />}
            {allProductsLogistics?.length === 0 && !isFetchingAllProductsLogistics &&
                <Alert variant="warning">Aucun produit n'a été trouvé</Alert>
            }
        </Row>
    </Container>;
};

export default ProductsList;
